export default __webpack_public_path__ + "static/media/mad_chatter.a127568e.png";